import React, { Fragment, useEffect, useState } from 'react';
import { Link } from '@ambiguous/link';
import gqlNav from "@assets/gql/nav.gql";
import { useQuery } from '@apollo/client';
import client from '../../apollo-client';
import { usePopper } from 'react-popper';
import nestChildren from '@assets/ts/nesting';
import IconSearch from '@assets/tsx/icon/search';
import MenuSocial from '../menu-social/menu-social';
import { useLang } from '@ambiguous/useLang';
import { createPortal } from 'react-dom';
export default function NavResponsive({ _id, menu, contacts_menu, social_menu, attach_to, custom_id, prefetch }) {
    var _a, _b, _c, _d, _e;
    const has_prefetch = ((_d = (_c = (_b = (_a = prefetch === null || prefetch === void 0 ? void 0 : prefetch.data) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.menuItems) === null || _c === void 0 ? void 0 : _c.nodes) === null || _d === void 0 ? void 0 : _d.length) > 0;
    const [language] = useLang();
    if (has_prefetch) {
        client.writeQuery({
            query: gqlNav,
            data: prefetch.data,
            variables: {
                id: parseInt(menu),
                language: language === null || language === void 0 ? void 0 : language.toUpperCase()
            }
        });
    }
    const [open, setOpen] = useState(false);
    const [wrapRef, setWrapRef] = useState(null);
    const [popperRef, setPopperRef] = useState(null);
    useEffect(() => {
        if (!(wrapRef instanceof HTMLElement))
            return;
        if (attach_to == 'section') {
            const closestSection = wrapRef.closest('section');
            setPopperRef(closestSection);
            return;
        }
        if (attach_to == "custom_id") {
            const customEl = document.getElementById(custom_id);
            customEl && setPopperRef(customEl);
            return;
        }
        if (attach_to == "fullscreen") {
            setPopperRef(document.body);
            return;
        }
        setPopperRef(wrapRef);
    }, [wrapRef, attach_to]);
    useEffect(() => { setOpen(false); }, [attach_to]);
    const elementor_id = _id ? _id : (_e = wrapRef === null || wrapRef === void 0 ? void 0 : wrapRef.closest('[data-id]')) === null || _e === void 0 ? void 0 : _e.dataset.id;
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: 'button', className: 'ltg-nav-responsive-button', onClick: () => { setOpen(!open); } },
            React.createElement("span", { className: "sr-only" }, "Meniu"),
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-menu" },
                React.createElement("line", { x1: "3", y1: "12", x2: "21", y2: "12" }),
                React.createElement("line", { x1: "3", y1: "6", x2: "21", y2: "6" }),
                React.createElement("line", { x1: "3", y1: "18", x2: "21", y2: "18" }))),
        React.createElement("div", { className: "ltg-nav-responsive", ref: setWrapRef }, (open && !!popperRef) && React.createElement(MenuPortal, { parent: popperRef, _id: elementor_id, menu: menu, popperRef: popperRef, attach_to: attach_to, social_menu: social_menu, contacts_menu: contacts_menu, setOpen: setOpen }))));
}
function MenuPortal(props) {
    const { _id, parent, menu, contacts_menu, social_menu, attach_to, popperRef, setOpen } = props;
    let portalEl = document.querySelector(`.ltg-nav-responsive-portal#nav-menu-${_id}`);
    if (!portalEl) {
        portalEl = document.createElement('div');
        portalEl.classList.add('ltg-nav-responsive-portal');
        portalEl.id = `nav-menu-${_id}`;
        document.body.appendChild(portalEl);
    }
    parent && parent.append(portalEl);
    return createPortal(React.createElement(Menu, { menu: menu, popperRef: popperRef, attach_to: attach_to, social_menu: social_menu, contacts_menu: contacts_menu, setOpen: setOpen }), portalEl);
}
function Menu(props) {
    const { menu, popperRef, attach_to, social_menu, contacts_menu, setOpen } = props;
    const [lang] = useLang();
    const { data, loading } = useQuery(gqlNav, {
        variables: { id: parseInt(menu), language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase() },
        client,
    });
    const [items, setItems] = useState([]);
    useEffect(() => {
        var _a, _b;
        const flat = (_b = (_a = data === null || data === void 0 ? void 0 : data.menu) === null || _a === void 0 ? void 0 : _a.menuItems) === null || _b === void 0 ? void 0 : _b.nodes;
        if (!flat)
            return;
        const nested = nestChildren(flat);
        nested && setItems(nested);
    }, [data]);
    const [popperEl, setPopperEl] = useState(null);
    const { styles, attributes } = usePopper(popperRef, popperEl, {
        placement: 'bottom-start',
        strategy: ['fullscreen', 'section'].includes(attach_to) ? 'fixed' : 'absolute'
    });
    return (React.createElement("div", Object.assign({ className: `ltg-nav-responsive-menu menu--${attach_to}`, ref: setPopperEl, style: attach_to === 'fullscreen' ? undefined : styles.popper }, attributes.popper),
        React.createElement(MenuHeader, { setOpen: setOpen }),
        loading ? (React.createElement(React.Fragment, null, "Loading")) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "ltg-nav-menu-content" },
                React.createElement("div", { className: ['fullscreen', 'section'].includes(attach_to) ? "container" : undefined },
                    items && React.createElement(MenuContent, { setOpen: setOpen, items: items }),
                    social_menu && React.createElement("div", { className: "ltg-nav-menu-social" },
                        React.createElement(MenuSocial, { color: 'black', menu: social_menu, type: 'rows' })),
                    contacts_menu && React.createElement(ContactsMenu, { contacts_menu: contacts_menu }))),
            React.createElement("div", { className: "ltg-nav-menu-footer" },
                React.createElement("form", { action: `/${(lang === null || lang === void 0 ? void 0 : lang.toLowerCase()) === 'lt' ? '' : lang === null || lang === void 0 ? void 0 : lang.toLowerCase()}`, className: 'ltg-nav-menu-search' },
                    React.createElement("input", { type: "text", name: 's' }),
                    React.createElement("button", null,
                        React.createElement(IconSearch, null))))))));
}
export function MenuHeader({ setOpen }) {
    return (React.createElement("div", { className: "ltg-nav-menu-header" },
        React.createElement("button", { className: "ltg-nav-close", onClick: () => { setOpen(false); } },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-x" },
                React.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
                React.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })))));
}
function MenuContent({ items, setOpen }) {
    const Item = ({ item, deep }) => {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(Link, { href: item.path, className: "ltg-nav-link", onClick: () => { setOpen(false); } }, item.label),
            ((_a = item === null || item === void 0 ? void 0 : item.childItems) === null || _a === void 0 ? void 0 : _a.nodes) && BuildItems(item.childItems.nodes, deep + 1)));
    };
    const BuildItems = (items, deep) => {
        return (React.createElement("ul", { className: `nav-menu--deep-${deep}` }, items && items.map(item => React.createElement("li", { key: item.id },
            React.createElement(Item, { item: item, deep: deep })))));
    };
    return (React.createElement("div", { className: "ltg-nav-menu-item-wrap" }, BuildItems(items, 0)));
}
function ContactsMenu({ contacts_menu }) {
    const { data, loading } = useQuery(gqlNav, {
        variables: {
            id: contacts_menu
        },
        client,
    });
    const [items, setItems] = useState([]);
    useEffect(() => {
        var _a, _b;
        if (!data)
            return;
        setItems((_b = (_a = data === null || data === void 0 ? void 0 : data.menu) === null || _a === void 0 ? void 0 : _a.menuItems) === null || _b === void 0 ? void 0 : _b.nodes);
    }, [data]);
    if (loading)
        return null;
    const Nested = ({ items }) => {
        return (React.createElement("div", { className: 'ltg-nav-menu-contact-item' }, items.map(({ id, path, label, description, target, childItems }) => {
            var _a;
            return (React.createElement(Fragment, { key: id },
                React.createElement(Link, { href: path, target: target, rel: target == '_blank' ? 'noreferrer noopener' : null, className: 'ltg-nav-menu-contact-link' },
                    React.createElement("div", { role: 'presentation', className: 'ltg-nav-menu-contact-link-title' }, label),
                    React.createElement("div", { className: 'ltg-nav-menu-contact-link-desc' }, description)),
                ((_a = childItems === null || childItems === void 0 ? void 0 : childItems.nodes) === null || _a === void 0 ? void 0 : _a.length) > 0 && React.createElement(Nested, { items: childItems.nodes })));
        })));
    };
    return (React.createElement("div", { className: "ltg-nav-menu-contact-wrap" }, items === null || items === void 0 ? void 0 : items.map(({ id, label, childItems }) => {
        var _a;
        return (React.createElement("div", { key: id, className: "ltg-nav-menu-contact-col" },
            React.createElement("h4", { className: 'ltg-nav-menu-contact-title', role: 'presentation' }, label),
            ((_a = childItems === null || childItems === void 0 ? void 0 : childItems.nodes) === null || _a === void 0 ? void 0 : _a.length) > 0 && React.createElement(Nested, { items: childItems.nodes })));
    })));
}
